import React, { useState } from 'react'
import {
  Typography, Button, IconButton,
  Table, TableBody, TableRow, TableHead, TableContainer, TableCell,
  Dialog, DialogActions, DialogContent, DialogTitle,
  Grid, TextField
} from '@mui/material'
import { Add, Edit, DeleteForever } from '@mui/icons-material'
import { Colors } from '../styles/theme'
import * as Yup from 'yup'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import './Brands.css'
import { useAppContext } from '../context/AppProvider'
import DeleteConfirmationDialog from './DeleteConfirmationDialog'
import { useCollections } from '../hooks/useCollections'

const validationData = Yup.object().shape({
  name: Yup.string().required('Name is required')

})

const Categories = () => {
  const { state } = useAppContext()
  const categories = state.collections.categories.data
  const { addCollections, deleteCollections, updateCollections } = useCollections()

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
  const [brandToDelete, setBrandToDelete] = useState(null)

  const [open, setOpen] = useState(false)
  const [initialValues, setInitialValues] = useState({
    _id: -1,
    name: '',
    type: 'categories',
    filters: ['price', 'brands'],
    link: '',
    sortPriority: state.collections.categories.data.length
  })
  const handleAddCategory = () => {
    setOpen(true)
    setInitialValues({
      _id: -1,
      name: '',
      type: 'categories',
      filters: ['price', 'brands'],
      link: '',
      sortPriority: state.collections.categories.data.length
    })
    setOpen(true)
  }

  const handleDelete = (product) => {
    deleteCollections(product)
  }

  const handleOpenDeleteDialog = (user) => {
    setBrandToDelete(user)
    setDeleteDialogOpen(true)
  }

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false)
    setBrandToDelete(null)
  }

  const handleConfirmDelete = () => {
    if (brandToDelete) {
      handleDelete(brandToDelete)
    }
    handleCloseDeleteDialog()
  }
  const handleEdit = (product) => {
    setInitialValues(product)
    setOpen(true)
  }

  const handleSubmit = async (values) => {
    setOpen(false)
    values.link = values.name.split(' ').join('-').toLowerCase()
    if (values._id === -1) {
      await addCollections(values)
    } else {
      await updateCollections(values)
    }
  }
  return (
    <>
      <Typography variant='h6' sx={{ marginBottom: '20px' }}>Categorii</Typography>
      <Button startIcon={<Add />} variant='outlined' onClick={handleAddCategory} sx={{ color: Colors.fontColor.main, borderColor: Colors.borderColor.main, marginBottom: '20px' }}>Adaugă categorie nouă</Button>
      <TableContainer>
        <Table>
        <TableHead>
          <TableRow>
            <TableCell>Nume</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            {categories.map(category =>
            <TableRow key={category._id}>
              {/* <TableCell>{product._id}</TableCell> */}
              <TableCell>{category.name}</TableCell>
              <TableCell>
                <IconButton onClick={() => handleEdit(category)}>
                  <Edit />
                </IconButton>
                <IconButton onClick={() => handleOpenDeleteDialog(category)}>
                  <DeleteForever sx={{ color: Colors.accent.main }}/>
                </IconButton>
              </TableCell>
            </TableRow>
            )}
        </TableBody>
        </Table>
      </TableContainer>
      <Dialog
      open={open}
      fullWidth
      maxWidth='lg'
      >
        <DialogTitle>
              {'Adaugă/modifică categoria'}
        </DialogTitle>
        <Formik initialValues={initialValues} validationSchema={validationData}
        onSubmit={handleSubmit}>
          {({ dirty, isValid, getFieldProps }) => (
          <Form>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid xs={12}>
                  <Field
                    as={TextField}
                    name='name'
                    label='Nume categorie'
                    fullWidth
                    required
                  />
                  <ErrorMessage name='name'>
                    {(message) => (
                      <Typography color={'red'}>{message}</Typography>
                    )}
                  </ErrorMessage>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
            {
                getFieldProps('_id').value !== -1
                  ? (
                <Button
               disabled={!dirty || !isValid}
               type='submit' variant='contained' color='primary'>Save Edit</Button>
                    )
                  : (
                <Button
               disabled={!dirty || !isValid}
               type='submit' variant='contained' color='primary'>Save</Button>
                    )
               }
              <Button autoFocus variant='contained' onClick={() => setOpen(false)}>Cancel</Button>
            </DialogActions>
          </Form>

          )}
        </Formik>
      </Dialog>
      <DeleteConfirmationDialog
      open={deleteDialogOpen}
      onClose={handleCloseDeleteDialog}
      onConfirm={handleConfirmDelete}
      object={brandToDelete ? brandToDelete.name : ''}
    />
    </>
  )
}

export default Categories
